import { fetchApi } from '@/config/axiosSetting';
import { PatchOtherCostQueryParamsType } from './patchOtherCosts.types';

export const patchOtherCostFunction = (
  params: PatchOtherCostQueryParamsType,
) => {
  return fetchApi.patch(
    `/property/reports/${params.id}/accident_users/other_damaged/adjusting/costs/`,
    {
      parts_transportation: params?.data?.parts_transportation || 0,
      parts_damage_total: params?.data?.parts_damage_total || 0,
    },
    {
      params: {
        damaged_id: params.damaged_id,
        id: params.id,
      },
    },
  );
};
